import {
    type FC
} from "react";
import type IFileUploadListProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    FILE_UPLOAD_STATUS_STATES,
    getFileDescription
} from "../../util";
import Attachment from "../../../attachment";
import Button from "../../../button";
import Text from "../../../text";

const FileUploadList: FC<IFileUploadListProps> = ({
    isInitialAnimated = false,
    isDisabled = false,
    customLocalize,
    customTheme,
    onRemove,
    onRetry,
    onUndo,
    title,
    rows,
    size
}) => {
    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    return <Attachment.Group
        isInitialAnimated={isInitialAnimated}
        customLocalize={customLocalize}
        customTheme={customTheme}
        style={stylesheet.group}
        layoutBehaviour="wrap"
        title={title}
    >
        {
            rows.map((row) => {
                if(row.kind === "removed") {
                    return <Attachment
                        customLocalize={customLocalize}
                        title={row.entry.file.name}
                        customTheme={customTheme}
                        key={row.entry.file.key}
                        uploadState="done"
                        size={size}
                    >
                        <Attachment.Media />
                        <Attachment.Content>
                            <Text
                                customTheme={customTheme}
                                variant="bodyMediumSize"
                                style={stylesheet.text}
                                numberOfLines={1}
                                color="mid"
                            >
                                {localize("file-upload-removed", [
                                    row.entry.file.name
                                ])}
                            </Text>
                        </Attachment.Content>
                        <Attachment.Actions>
                            <Button
                                accessibilityLabel={localize("file-upload-undo-label", [
                                    row.entry.file.name
                                ])}
                                title={localize("file-upload-undo")}
                                customTheme={customTheme}
                                isDisabled={isDisabled}
                                onPress={() => {
                                    onUndo(row.entry);
                                }}
                                spreadBehaviour="free"
                                variant="ghost"
                                type="neutral"
                                size="small"
                            />
                        </Attachment.Actions>
                    </Attachment>;
                }

                const {
                    file
                } = row;

                return <Attachment
                    uploadState={FILE_UPLOAD_STATUS_STATES[file.status ?? "queued"]}
                    onRemove={isDisabled ? undefined : () => {
                        onRemove(file);
                    }}
                    onRetry={onRetry && !isDisabled ? () => {
                        onRetry(file);
                    } : undefined}
                    description={getFileDescription({
                        locale: activeLocale,
                        file
                    })}
                    customLocalize={customLocalize}
                    source={file.previewUri ? {
                        uri: file.previewUri
                    } : undefined}
                    errorText={file.errorText}
                    customTheme={customTheme}
                    progress={file.progress}
                    title={file.name}
                    key={file.key}
                    size={size}
                />;
            })
        }
    </Attachment.Group>;
};
export default FileUploadList;
